function initDeframePdpSection(section) {
  if (section.dataset.deframeInitialized === 'true') return;
  section.dataset.deframeInitialized = 'true';

  const variantsJson = section.querySelector('[data-variants-json]');
  if (!variantsJson) return;

  const variants = JSON.parse(variantsJson.textContent);
  const hasSize = section.dataset.hasSize === 'true';
  const restockLocked = section.dataset.restockLocked === 'true';

  const sizeButtons = [...section.querySelectorAll('[data-size-button]')];
  const linkedColorLinks = [...section.querySelectorAll('.deframe-pdp__linked-color')];

  const variantIdInput = section.querySelector('[data-variant-id-input]');
  const atcButton = section.querySelector('[data-atc-button]');
const atcLabel = section.querySelector('[data-atc-label]');
const atcPrice = section.querySelector('[data-atc-price]');

const stickyAtc = section.querySelector('[data-sticky-atc]');
const stickyAtcButton = section.querySelector('[data-sticky-atc-button]');
const stickyAtcLabel = section.querySelector('[data-sticky-atc-label]');
const stickyAtcPrice = section.querySelector('[data-sticky-atc-price]');

const stockMessage = section.querySelector('[data-stock-message]');
  const productForm = section.querySelector('form[action*="/cart/add"]');

  const mediaWrap = section.querySelector('.deframe-pdp__media');
  const mediaDesktop = section.querySelector('.deframe-pdp__media-desktop');
  const thumbRail = section.querySelector('.deframe-pdp__thumb-rail');
  const thumbs = [...section.querySelectorAll('.deframe-pdp__thumb')];
  const mediaItems = [...section.querySelectorAll('.deframe-pdp__media-item')];

  const mobileSlider = section.querySelector('.deframe-pdp__media-slider');
  const mobileSlides = [...section.querySelectorAll('.deframe-pdp__media-slide')];
  const mobileProgressBar = section.querySelector('[data-mobile-progress-bar]');

  const fs = section.querySelector('[data-df-fs]');
  const fsClose = section.querySelector('[data-df-fs-close]');
  const fsZoom = section.querySelector('[data-df-fs-reset]');
  const fsDesktopGallery = section.querySelector('[data-df-fs-desktop-gallery]');
  const fsDesktopItems = [...section.querySelectorAll('[data-df-fs-item]')];
  const fsMobile = section.querySelector('[data-df-fs-mobile-slider]');
  const fsMobileSlides = [...section.querySelectorAll('[data-df-fs-mobile-slide]')];

  const drawer = section.querySelector('[data-drawer]');
  const drawerTabs = [...section.querySelectorAll('[data-drawer-tab]')];
  const drawerContents = [...section.querySelectorAll('[data-drawer-content]')];
  const drawerOpenButtons = [...section.querySelectorAll('[data-drawer-open]')];
  const drawerClose = section.querySelector('[data-drawer-close]');

  let selectedSize = '';
  let selectedVariant = null;
  let lastScrollY = window.scrollY;

  const moneyFormat = window.Shopify?.money_format || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function getFirstAvailableVariant() {
  const availableVariants = variants.filter((variant) => variant.available);

  if (!availableVariants.length) return variants[0] || null;

  return availableVariants.reduce((lowest, variant) => {
    return variant.price < lowest.price ? variant : lowest;
  }, availableVariants[0]);
}

  function getMatchingVariant() {
    if (!hasSize) return getFirstAvailableVariant();

    return (
      variants.find((variant) => {
        return (
          (variant.option1 === selectedSize ||
            variant.option2 === selectedSize ||
            variant.option3 === selectedSize) &&
          variant.available
        );
      }) || null
    );
  }

  function updateActiveButtons() {
    sizeButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.value === selectedSize);
    });
  }

  function updatePrice() {
  const priceSource = selectedVariant || getFirstAvailableVariant();

  if (!priceSource || !atcPrice) return;

  if (priceSource.compare_at_price > priceSource.price) {
    atcPrice.innerHTML =
      `<span class="df-price--compare">LE ${formatMoney(priceSource.compare_at_price).replace(/[^\d.,]/g, '')}</span>
       <span class="df-price--sale">LE ${formatMoney(priceSource.price).replace(/[^\d.,]/g, '')}</span>`;
  } else {
    atcPrice.textContent =
      'LE ' + formatMoney(priceSource.price).replace(/[^\d.,]/g, '');
  }
}

function updateStockMessage() {
  if (!stockMessage) return;

  stockMessage.classList.remove('is-active');
  stockMessage.textContent = '';

  if (!selectedSize) return;

  const activeButton = sizeButtons.find(
    (btn) => btn.dataset.value === selectedSize
  );

  if (!activeButton) return;

  const qty = Number(activeButton.dataset.inventoryQuantity);

  if (!Number.isFinite(qty)) return;

  if (qty > 0 && qty <= 5) {
    stockMessage.innerHTML = 'Only <strong>' + qty + '</strong> left in this size';
    stockMessage.classList.add('is-active');
  }
}

  function updateButtonState() {
  const hasAvailableVariant = variants.some((variant) => variant.available);

  if (restockLocked) {
  selectedVariant = null;

  if (atcButton) {
    atcButton.disabled = true;
    atcButton.classList.add('is-sold-out');
  }

  if (atcLabel) atcLabel.textContent = 'Sold out';
  if (variantIdInput) variantIdInput.value = '';

  return;
}

  if (!hasAvailableVariant) {
    selectedVariant = null;

    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.add('is-sold-out');
    }

    if (atcLabel) atcLabel.textContent = 'Sold out';
    if (variantIdInput) variantIdInput.value = '';

    return;
  }

  selectedVariant = getMatchingVariant();

  if (!selectedSize && hasSize) {
    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.remove('is-sold-out');
    }

    if (atcLabel) atcLabel.textContent = 'Select size';
    if (variantIdInput) variantIdInput.value = '';

    return;
  }

  if (!selectedVariant) {
    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.add('is-sold-out');
    }

    if (atcLabel) atcLabel.textContent = 'Sold out';
    if (variantIdInput) variantIdInput.value = '';

    return;
  }

  if (variantIdInput) variantIdInput.value = selectedVariant.id;

  if (selectedVariant.available) {
    if (atcButton) {
      atcButton.disabled = false;
      atcButton.classList.remove('is-sold-out');
    }

    if (atcLabel) atcLabel.textContent = 'Add to cart';
  } else {
    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.add('is-sold-out');
    }

    if (atcLabel) atcLabel.textContent = 'Sold out';
  }
}

  function syncStickyAtc() {
  if (!stickyAtcButton) return;

  stickyAtcButton.disabled = atcButton ? atcButton.disabled : true;

  if (stickyAtcLabel && atcLabel) {
    stickyAtcLabel.textContent = atcLabel.textContent;
  }

  if (stickyAtcPrice && atcPrice) {
    stickyAtcPrice.innerHTML = atcPrice.innerHTML;
  }

  stickyAtcButton.classList.toggle(
    'is-sold-out',
    atcButton?.classList.contains('is-sold-out')
  );
}

function syncAll() {
  selectedVariant = getMatchingVariant();
  updateActiveButtons();
  updateButtonState();
  updatePrice();
  updateStockMessage();
  syncStickyAtc();
}

  function updateActiveThumb() {
    if (!thumbs.length || !mediaItems.length) return;

    let activeId = null;
    let smallestOffset = Infinity;

    mediaItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const offset = Math.abs(rect.top);

      if (offset < smallestOffset) {
        smallestOffset = offset;
        activeId = item.dataset.mediaId;
      }
    });

    thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.thumbTarget === activeId);
    });
  }

  function updateThumbRailState() {
    if (!thumbRail || !mediaWrap || !mediaDesktop) return;

    if (window.innerWidth <= 989) {
      thumbRail.classList.add('is-hidden');
      mediaWrap.classList.remove('is-thumb-sticky', 'is-thumb-bottom');
      lastScrollY = window.scrollY;
      return;
    }

    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;
    const scrollingUp = currentScrollY < lastScrollY;

    const wrapRect = mediaWrap.getBoundingClientRect();
    const desktopRect = mediaDesktop.getBoundingClientRect();

    const enteredMedia = desktopRect.top <= window.innerHeight;
    const mediaBottomReachedViewportBottom = wrapRect.bottom <= window.innerHeight;
    const insideMediaZone = enteredMedia && wrapRect.bottom > 0;

    if (!insideMediaZone) {
      thumbRail.classList.add('is-hidden');
      mediaWrap.classList.remove('is-thumb-sticky', 'is-thumb-bottom');
      lastScrollY = currentScrollY;
      return;
    }

    if (mediaBottomReachedViewportBottom) {
      mediaWrap.classList.remove('is-thumb-sticky');
      mediaWrap.classList.add('is-thumb-bottom');
    } else {
      mediaWrap.classList.add('is-thumb-sticky');
      mediaWrap.classList.remove('is-thumb-bottom');
    }

    if (currentScrollY <= 40) {
      thumbRail.classList.remove('is-hidden');
    } else if (scrollingDown) {
      thumbRail.classList.add('is-hidden');
    } else if (scrollingUp) {
      thumbRail.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  }

  function updateMobileProgress() {
    if (!mobileSlider || !mobileSlides.length || !mobileProgressBar) return;

    const slideWidth = mobileSlider.clientWidth;
    if (!slideWidth) return;

    const currentIndex = Math.round(mobileSlider.scrollLeft / slideWidth);
    const totalSlides = mobileSlides.length;

    const barWidth = 100 / totalSlides;
    mobileProgressBar.style.width = `${barWidth}%`;
    mobileProgressBar.style.transform = `translateX(${currentIndex * 100}%)`;
  }

  function setFsNormalState() {
    if (!fs) return;
    fs.classList.remove('is-zoomed');
  }

  function openFs(mediaId) {
    if (!fs) return;

    setFsNormalState();

    fs.classList.add('is-open');
    fs.setAttribute('aria-hidden', 'false');

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      if (window.innerWidth > 989) {
        const target = fsDesktopItems.find((item) => String(item.dataset.mediaId) === String(mediaId));

        if (target && fsDesktopGallery) {
          fsDesktopGallery.scrollTop = target.offsetTop;
        }
      } else {
        const index = fsMobileSlides.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));

        if (index > -1 && fsMobile) {
          fsMobile.scrollLeft = fsMobile.clientWidth * index;
        }
      }
    });
  }

  function closeFs() {
    if (!fs) return;

    fs.classList.remove('is-open', 'is-zoomed');
    fs.setAttribute('aria-hidden', 'true');

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  async function swapProductPage(url, pushState = true) {
    try {
      section.classList.add('is-loading');

      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Failed to load product page');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newSection = doc.querySelector('.deframe-pdp');
      const currentSection = document.querySelector('.deframe-pdp');

      if (!newSection || !currentSection) {
        window.location.href = url;
        return;
      }

      currentSection.replaceWith(newSection);

      if (pushState) window.history.pushState({ url }, '', url);
      if (doc.title) document.title = doc.title;

      initDeframePdpSection(newSection);

      newSection.querySelector('.deframe-pdp__breadcrumbs')?.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    } catch (error) {
      console.error(error);
      window.location.href = url;
    }
  }

  linkedColorLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      const url = link.getAttribute('href');
      if (url) swapProductPage(url, true);
    });
  });

  sizeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.disabled) return;

      selectedSize = button.dataset.value;
      syncAll();
    });
  });

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const targetId = thumb.dataset.thumbTarget;
      const target = section.querySelector(`.deframe-pdp__media-item[data-media-id="${targetId}"]`);

      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });

  mediaItems.forEach((item) => {
    item.addEventListener('click', () => {
      openFs(item.dataset.mediaId);
    });
  });

  mobileSlides.forEach((item) => {
    item.addEventListener('click', () => {
      openFs(item.dataset.mediaId);
    });
  });

  fsDesktopItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      closeFs();
    });
  });

  fsMobileSlides.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      closeFs();
    });
  });

  if (fsClose) {
    fsClose.addEventListener('click', (event) => {
      event.stopPropagation();
      closeFs();
    });
  }

  if (fsZoom) {
    fsZoom.addEventListener('click', (event) => {
      event.stopPropagation();
      closeFs();
    });
  }

  function openDrawer(tabName) {
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    document.body.classList.add('df-pdp-drawer-open');

    drawerTabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.drawerTab === tabName);
    });

    drawerContents.forEach((content) => {
      content.classList.toggle('is-active', content.dataset.drawerContent === tabName);
    });
  }

  function closeDrawer() {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('df-pdp-drawer-open');
  }

  drawerOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      openDrawer(button.dataset.tab);
    });
  });

  drawerTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      openDrawer(tab.dataset.drawerTab);
    });
  });

  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

  if (drawer) {
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });
  }

  async function addToCartAjax() {
  if (!variantIdInput || !variantIdInput.value) {
    section.querySelector('[data-size-list]')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    return;
  }

  if (!atcButton || atcButton.disabled) return;

  const originalLabel = atcLabel ? atcLabel.textContent : 'Add to cart';

  atcButton.disabled = true;
  if (atcLabel) atcLabel.textContent = 'Adding';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantIdInput.value),
        quantity: 1
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    if (typeof window.renderCart === 'function') {
      await window.renderCart();
    }

    if (typeof window.dfSyncCartIconBubble === 'function') {
      window.dfSyncCartIconBubble();
    }

    if (typeof window.openDeframeCart === 'function') {
      window.openDeframeCart();
    }

    if (atcLabel) atcLabel.textContent = 'Added';

    setTimeout(() => {
      if (atcLabel) atcLabel.textContent = originalLabel;
      atcButton.disabled = false;
      updateButtonState();
    }, 800);
  } catch (error) {
    console.error(error);

    if (atcLabel) atcLabel.textContent = 'Unavailable';

    setTimeout(() => {
      if (atcLabel) atcLabel.textContent = originalLabel;
      atcButton.disabled = false;
      updateButtonState();
    }, 1200);
  }
}

  if (productForm) {
  productForm.addEventListener('submit', (event) => {
    event.preventDefault();
    event.stopPropagation();
    addToCartAjax();
  });
}

if (stickyAtcButton) {
  stickyAtcButton.addEventListener('click', () => {
    if (stickyAtcButton.disabled || !atcButton) return;

    atcButton.click();
  });
}

function initCompleteSetBlocks() {
  const completeSetBlocks = [...section.querySelectorAll('[data-complete-set]')];

  completeSetBlocks.forEach((block) => {
    const variantsJson = block.querySelector('[data-complete-set-variants]');
    const sizeButtons = [...block.querySelectorAll('[data-complete-set-size]')];
    const addButton = block.querySelector('[data-complete-set-add]');
    const restockLocked = block.dataset.restockLocked === 'true';
    const comingSoon = block.dataset.comingSoon === 'true';

    if (!variantsJson || !addButton) return;

    let setVariants = [];

    try {
      setVariants = JSON.parse(variantsJson.textContent);
    } catch (error) {
      console.error(error);
      return;
    }

    let selectedSetSize = '';
    let selectedSetVariant = null;

    function getSetVariant() {
      if (!sizeButtons.length) {
        return setVariants.find((variant) => variant.available) || null;
      }

      return (
        setVariants.find((variant) => {
          return (
            variant.available &&
            (variant.option1 === selectedSetSize ||
              variant.option2 === selectedSetSize ||
              variant.option3 === selectedSetSize)
          );
        }) || null
      );
    }

    function syncSetState() {
      selectedSetVariant = getSetVariant();
      
      if (comingSoon) {
  selectedSetVariant = null;
  addButton.disabled = true;
  addButton.classList.add('is-unavailable');
  addButton.classList.remove('is-sold-out');
  addButton.textContent = 'Coming soon';
  return;
}

      if (restockLocked) {
  selectedSetVariant = null;
  addButton.disabled = true;
  addButton.classList.add('is-unavailable', 'is-sold-out');
  addButton.textContent = 'Sold out';
  return;
}

      sizeButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.value === selectedSetSize);
      });

      const hasAvailableVariant = setVariants.some((variant) => variant.available);

      if (!hasAvailableVariant) {
        addButton.disabled = true;
        addButton.classList.add('is-unavailable');
        return;
      }

      addButton.classList.remove('is-unavailable');

      if (!sizeButtons.length && selectedSetVariant) {
        addButton.disabled = false;
        return;
      }

      addButton.disabled = !selectedSetVariant;
    }

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;

        selectedSetSize = button.dataset.value;
        syncSetState();
      });
    });

    addButton.addEventListener('click', async () => {
      if (!selectedSetVariant || addButton.disabled) return;

      const originalText = addButton.textContent;

      addButton.disabled = true;
      addButton.textContent = 'Adding';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(selectedSetVariant.id),
            quantity: 1
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (typeof window.renderCart === 'function') {
          await window.renderCart();
        }

        if (typeof window.dfSyncCartIconBubble === 'function') {
          window.dfSyncCartIconBubble();
        }

        if (typeof window.openDeframeCart === 'function') {
          window.openDeframeCart();
        }

        addButton.textContent = 'Added';

        setTimeout(() => {
          addButton.textContent = originalText;
          syncSetState();
        }, 900);
      } catch (error) {
        console.error(error);

        addButton.textContent = 'Unavailable';

        setTimeout(() => {
          addButton.textContent = originalText;
          syncSetState();
        }, 1200);
      }
    });

    syncSetState();
  });
}

initCompleteSetBlocks();

  const handleScroll = () => {
  updateThumbRailState();
  updateActiveThumb();

  if (stickyAtc && atcButton) {
    const atcRect = atcButton.getBoundingClientRect();

    stickyAtc.classList.toggle(
      'is-visible',
      atcRect.bottom < 0
    );
  }
};

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleScroll);

  if (mobileSlider) {
    mobileSlider.addEventListener('scroll', updateMobileProgress, { passive: true });
    window.addEventListener('resize', updateMobileProgress);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    if (event.key === 'Escape' && fs?.classList.contains('is-open')) closeFs();
  });

  updateThumbRailState();
  updateActiveThumb();
  updateMobileProgress();
  syncAll();
}

function initAllDeframePdps() {
  const sections = document.querySelectorAll('.deframe-pdp');
  sections.forEach((section) => initDeframePdpSection(section));
}

document.addEventListener('DOMContentLoaded', initAllDeframePdps);

window.addEventListener('popstate', () => {
  const currentSection = document.querySelector('.deframe-pdp');
  if (!currentSection) return;

  fetch(window.location.href, {
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.querySelector('.deframe-pdp');

      if (!newSection) return;

      currentSection.replaceWith(newSection);
      initDeframePdpSection(newSection);

      if (doc.title) document.title = doc.title;
    })
    .catch((error) => {
      console.error(error);
      window.location.reload();
    });
});